import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-02f78c5e"), n = n(), _popScopeId(), n);
const _hoisted_1 = { id: "airport-overlay-container" };
const _hoisted_2 = { id: "airport-title" };
const _hoisted_3 = ["src"];
const _hoisted_4 = { class: "airport-info-container" };
const _hoisted_5 = { class: "airport-title-info-container" };
const _hoisted_6 = _withScopeId(() => _createElementVNode("p", null, "ATIS", -1));
const _hoisted_7 = { id: "airport-atis-message" };
const _hoisted_8 = _withScopeId(() => _createElementVNode("hr", null, null, -1));
const _hoisted_9 = { class: "airport-info-container" };
const _hoisted_10 = { class: "airport-title-info-container" };
const _hoisted_11 = _withScopeId(() => _createElementVNode("p", null, "ATC", -1));
const _hoisted_12 = { id: "airport-atc-frequency-container" };
const _hoisted_13 = { class: "grid-center flex-gap-mini" };
const _hoisted_14 = _withScopeId(() => _createElementVNode("p", null, "Ground", -1));
const _hoisted_15 = { class: "grid-center flex-gap-mini" };
const _hoisted_16 = _withScopeId(() => _createElementVNode("p", null, "Tower", -1));
const _hoisted_17 = { class: "grid-center flex-gap-mini" };
const _hoisted_18 = _withScopeId(() => _createElementVNode("p", null, "Approach", -1));
const _hoisted_19 = { class: "grid-center flex-gap-mini" };
const _hoisted_20 = _withScopeId(() => _createElementVNode("p", null, "Departure", -1));
const _hoisted_21 = _withScopeId(() => _createElementVNode("hr", null, null, -1));
const _hoisted_22 = { class: "airport-info-container" };
const _hoisted_23 = { class: "airport-title-info-container" };
const _hoisted_24 = _withScopeId(() => _createElementVNode("p", null, "Departures", -1));
const _hoisted_25 = _withScopeId(() => _createElementVNode("div", { class: "airport-flights-item-title margin-right-scroll" }, [
    _createElementVNode("p", null, "Callsign"),
    _createElementVNode("p", null, "Username"),
    _createElementVNode("p", null, "Aircraft")
], -1));
const _hoisted_26 = _withScopeId(() => _createElementVNode("hr", { class: "dashed" }, null, -1));
const _hoisted_27 = { class: "airport-flights" };
const _hoisted_28 = ["onClick"];
const _hoisted_29 = { class: "airport-flights-item" };
const _hoisted_30 = _withScopeId(() => _createElementVNode("hr", null, null, -1));
const _hoisted_31 = { class: "airport-info-container" };
const _hoisted_32 = { class: "airport-title-info-container" };
const _hoisted_33 = _withScopeId(() => _createElementVNode("p", null, "Arrivals", -1));
const _hoisted_34 = _withScopeId(() => _createElementVNode("div", { class: "airport-flights-item-title margin-right-scroll" }, [
    _createElementVNode("p", null, "Callsign"),
    _createElementVNode("p", null, "Username"),
    _createElementVNode("p", null, "Aircraft")
], -1));
const _hoisted_35 = _withScopeId(() => _createElementVNode("hr", { class: "dashed" }, null, -1));
const _hoisted_36 = { class: "airport-flights" };
const _hoisted_37 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_InlineSvg = _resolveComponent("InlineSvg");
    const _component_Dot = _resolveComponent("Dot");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.airportTitle), 1),
        _createElementVNode("img", {
            class: "full-width",
            src: _ctx.imageSrc,
            alt: "airport image",
            onerror: "if(this.src != 'img/404.webp') this.src='img/404.webp'"
        }, null, 8, _hoisted_3),
        _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_InlineSvg, {
                    src: "svg/broadcast.svg",
                    class: "airport-title-icon"
                }),
                _hoisted_6
            ]),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.atis), 1)
        ]),
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_InlineSvg, {
                    src: "svg/atc.svg",
                    class: "airport-title-icon"
                }),
                _hoisted_11
            ]),
            _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createVNode(_component_Dot, { active: _ctx.isGroundActive }, null, 8, ["active"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createVNode(_component_Dot, { active: _ctx.isTowerActive }, null, 8, ["active"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createVNode(_component_Dot, { active: _ctx.isApproachActive }, null, 8, ["active"])
                ]),
                _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createVNode(_component_Dot, { active: _ctx.isDepartureActive }, null, 8, ["active"])
                ])
            ])
        ]),
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_InlineSvg, {
                    src: "svg/departure.svg",
                    class: "airport-title-icon"
                }),
                _hoisted_24
            ]),
            _hoisted_25,
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.departures, (flight) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: flight.id,
                        onClick: ($event) => (_ctx.onFlightClick(flight.id))
                    }, [
                        _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("p", null, _toDisplayString(flight.callsign), 1),
                            _createElementVNode("p", null, _toDisplayString(flight.username), 1),
                            _createElementVNode("p", null, _toDisplayString(flight.aircraftName), 1)
                        ])
                    ], 8, _hoisted_28));
                }), 128))
            ])
        ]),
        _hoisted_30,
        _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_InlineSvg, {
                    src: "svg/arrival.svg",
                    class: "airport-title-icon"
                }),
                _hoisted_33
            ]),
            _hoisted_34,
            _hoisted_35,
            _createElementVNode("div", _hoisted_36, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrivals, (flight) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: flight.id
                    }, [
                        _createElementVNode("div", {
                            class: "airport-flights-item",
                            onClick: ($event) => (_ctx.onFlightClick(flight.id))
                        }, [
                            _createElementVNode("p", null, _toDisplayString(flight.callsign), 1),
                            _createElementVNode("p", null, _toDisplayString(flight.username), 1),
                            _createElementVNode("p", null, _toDisplayString(flight.aircraftName), 1)
                        ], 8, _hoisted_37)
                    ]));
                }), 128))
            ])
        ])
    ]));
}
